/**
 * All vuesax framework options listed here
 * all options listed here are reactive
 */
export default {
  rtl: false,
};
